import {
    REQUEST_ATP_TYPES,
    REQUEST_ATP_TYPES_SUCCESS,
    REQUEST_ATP_ACTIVE,
    REQUEST_ATP_ACTIVE_SUCCESS,
    REQUEST_ATP_COMPLETED,
    REQUEST_ATP_COMPLETED_SUCCESS,
    UPDATE_ADAPTIVE_PLAN_STATUS_SUCCESS,
    FETCH_ADAPTIVE_PLAN,
    FETCH_ADAPTIVE_PLAN_SUCCESS,
    FETCH_ADAPTIVE_PLAN_ERROR,
    FETCH_COACH_PLAN,
    FETCH_COACH_PLAN_SUCCESS,
    FETCH_PLAN_CONTENT_SUCCESS,
    FETCH_PLAN_CONTENT_ERROR,
    PLAN_SETUP_RESET,
    UPDATE_PLAN_SETUP,
    FETCH_PREPLAN_DISTANCE_SUCCESS,
    FETCH_PREPLAN_DISTANCE_ERROR,
    FETCH_COACH_CAUTION_SUCCESS,
    FETCH_COACH_CAUTION_ERROR,
    FETCH_PREPLAN_PACE_SUCCESS,
    FETCH_PREPLAN_PACE_ERROR,
    FETCH_PREPLAN_GOALS_SUCCESS,
    FETCH_PREPLAN_GOALS_ERROR,
    FETCH_PREPLAN_PACE_TIMES_SUCCESS,
    FETCH_PREPLAN_PACE_TIMES_ERROR,
    FETCH_PREPLAN_COACHES_SUCCESS,
    FETCH_PREPLAN_COACHES_ERROR,
    FETCH_PREPLAN_COACH_INFO_SUCCESS,
    FETCH_PREPLAN_COACH_INFO_ERROR,
    FETCH_COACH_VIDEO_SUCCESS,
    FETCH_COACH_VIDEO_ERROR,
    RESET_ATP_PLAN,
    REQUEST_ATP_ACTIVE_FETCHING,
    REQUEST_ATP_ACTIVE_FAIL,
    RESET_PREPLAN_DISTANCE,
    RESET_PREPLAN_PACE_TIMES,
    RESET_PREPLAN_PACE,
    RESET_COACH_VIDEO
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isEntityFetching: false,
    isPlanTypesFetchError: false,
    isActivePlanFetchError: false,
    isActivePlanFetchSuccess: false,
    isCompletedPlanFetchError: false,
    entity: null,
    atpPlanTypes: [],
    completedPlans: [],
    activePlans: [],
    status: null,
    content: {},
    inProcessPlanSetup: {
        planTypeId: null,
        selectedGoal: null,
        prePlanWeeklyMileage: null,
        prePlanTrainingPace: null,
        selectedPaceGoalTime: null,
        longRunDay: null,
        selectedRace: null,
        selectedWorkoutDays: [],
        selectedWorkoutPlanId: null,
        selectedWorkoutsPerWeek: null,
        // Needed only for user to select workouts per week and days available
        // Not needed to send to API
        overview: {
            maxWeeksPerPlan: null,
            maxWorkoutsPerWeek: null,
            minWeeksPerPlan: null,
            minWorkoutsPerWeek: null,
            coachId: null
        }
    },
    coachAction: {
        data: {},
        success: false,
        error: false
    },
    preplanDistance: {},
    preplanPace: {},
    preplanGoals: {},
    preplanPaceTimes: {
        success: false,
        error: false,
        data: {}
    },
    preplanCoaches: [],
    preplanCoachInfo: {},
    coachInfoWithVideo: {}
};

//Get ATP Plan
const fetchATPPlanSuccess = (state, action) => {
    return {
        ...state,
        isEntityFetching: false,
        entity: action.atpPlan,
        status: null
    };
};

const fetchATPPlanError = (state, action) => {
    return {
        ...state,
        entity: INITIAL_STATE.entity,
        isEntityFetching: false,
        status: action.error.response.status
    };
};

//Get ATP Plan Types
const receiveAdaptiveTrainingPlanTypes = (state, action) => {
    return {
        ...state,
        isEntityFetching: false,
        isPlanTypesFetchError: false,
        atpPlanTypes: [...action.atpPlanTypes]
    };
};

//Get Active / Completed ATP Plans
const receiveActiveAdaptiveTrainingPlans = (state, action) => {
    return {
        ...state,
        isEntityFetching: false,
        isActivePlanFetchError: false,
        isActivePlanFetchSuccess: true,
        activePlans: [...action.activePlans]
    };
};

const fetchingActiveAdaptiveTrainingPlans = (state) => {
    return {
        ...state,
        isEntityFetching: true,
        isActivePlanFetchError: false,
        isActivePlanFetchSuccess: false,
        activePlans: []
    };
};

const fetchingActiveAdaptiveTrainingPlansFail = (state) => {
    return {
        ...state,
        isEntityFetching: false,
        isActivePlanFetchError: true,
        isActivePlanFetchSuccess: false,
        activePlans: []
    };
};

const receiveCompletedAdaptiveTrainingPlans = (state, action) => {
    return {
        ...state,
        isEntityFetching: false,
        isCompletedPlanFetchError: false,
        completedPlans: [...action.completedPlans]
    };
};

const fetchCoachPlanSuccess = (state, action) => {
    return {
        ...state,
        coachPlan: action.coachPlan
    };
};

//Updates to ATP Plan Statuses
const updateAtpPlanStatus = (state = {}, action = {}) => {
    if (action.type === UPDATE_ADAPTIVE_PLAN_STATUS_SUCCESS) {
        switch (action.planStatus) {
            case 'pause':
                return pausePlan(state, action);
            case 'unpause':
                return unPausePlan(state, action);
            case 'quit':
                return quitPlan(state, action);
            case 'complete':
                return completePlan(state, action);
            case 'react':
                return reactToCoach(state, action);
            default:
                return state;
        }
    }
    return state;
};

const fetchPlanContent = (success) => (state, action) => {
    return {
        ...state,
        content: {
            [action.workoutPlanTypeId]: {
                success: success,
                error: !success,
                data: success ? { ...action.data } : null
            }
        }
    };
};

const fetchCoachCaution = (success) => (state, action) => {
    return {
        ...state,
        coachAction: {
            success: success,
            error: !success,
            data: action.data
        }
    };
};

const fetchPreplanDistance = (success) => (state, action) => {
    return {
        ...state,
        preplanDistance: success ? action.data : {}
    };
};

const fetchPreplanPace = (success) => (state, action) => {
    return {
        ...state,
        preplanPace: success ? action.data : {}
    };
};

const fetchPreplanGoals = (success) => (state, action) => {
    return {
        ...state,
        preplanGoals: success ? action.data : {}
    };
};

const fetchPreplanPaceTimes = (success) => (state, action) => {
    return {
        ...state,
        preplanPaceTimes: {
            ...state.preplanPaceTimes,
            success: success,
            error: !success,
            data: success ? action.data : {}
        }
    };
};

const fetchPreplanCoaches = (success) => (state, action) => {
    return {
        ...state,
        preplanCoaches: success ? action.data : []
    };
};

const fetchPreplanCoachInfo = (success) => (state, action) => {
    let key = action.data.contentfulContentId;
    return {
        ...state,
        preplanCoachInfo: {
            ...state.preplanCoachInfo,
            [key]: success ? action.data.atpCoachInfo : null
        }
    };
};

const fetchCoachVideo = (success) => (state, action) => {
    let key = action.data.contentfulContentId;
    return {
        ...state,
        coachInfoWithVideo: {
            ...state.coachInfoWithVideo,
            [key]: success ? { coachInfo: action.data.coachInfo, videoData: action.data.videoData } : null
        }
    };
};

function update(previousState, newValues) {
    return Object.assign({}, previousState, newValues);
}

function pausePlan(state, action) {
    var atpPlan = update(state.entity, {
        pause: {
            date: action.response.date,
            state: true
        }
    });

    return {
        ...state,
        entity: atpPlan
    };
}

function unPausePlan(state, action) {
    var atpPlan = update(state.entity, {
        pause: null
    });

    return {
        ...state,
        entity: atpPlan
    };
}

function quitPlan(state, action) {
    var atpPlan = update(state.entity, {
        quit: {
            date: action.response.date,
            state: true
        }
    });

    return {
        ...state,
        entity: atpPlan
    };
}

function completePlan(state, action) {
    var atpPlan = update(state.entity, {
        planCompleted: true
    });

    return {
        ...state,
        entity: atpPlan
    };
}

function reactToCoach(state, action) {
    return state;
}

const resetPlanSetup = (state) => {
    return {
        ...state,
        inProcessPlanSetup: INITIAL_STATE.inProcessPlanSetup
    };
};

const updatePlanSetup = (state, action) => {
    let updatedPlan = {
        ...state.inProcessPlanSetup,
        ...action.data,
        overview: {
            ...state.inProcessPlanSetup.overview,
            ...action.data.overview
        }
    };
    return {
        ...state,
        inProcessPlanSetup: updatedPlan
    };
};

const resetAtpPlan = (state) => {
    return {
        ...state,
        entity: null
    };
};

const resetPreplanDistance = (state) => {
    return {
        ...state,
        preplanDistance: {}
    };
};

const resetPreplanPaceTimes = (state) => {
    return {
        ...state,
        preplanPaceTimes: {
            success: false,
            error: false,
            data: {}
        }
    };
};

const resetPreplanPace = (state) => {
    return {
        ...state,
        preplanPace: {}
    };
};

const resetCoachVideo = (state) => {
    return {
        ...state,
        coachInfoWithVideo: {}
    };
};

const handlers = {
    [FETCH_ADAPTIVE_PLAN_SUCCESS]: fetchATPPlanSuccess,
    [FETCH_ADAPTIVE_PLAN_ERROR]: fetchATPPlanError,
    [REQUEST_ATP_TYPES_SUCCESS]: receiveAdaptiveTrainingPlanTypes,
    [REQUEST_ATP_ACTIVE_SUCCESS]: receiveActiveAdaptiveTrainingPlans,
    [REQUEST_ATP_COMPLETED_SUCCESS]: receiveCompletedAdaptiveTrainingPlans,
    [FETCH_COACH_PLAN_SUCCESS]: fetchCoachPlanSuccess,
    [UPDATE_ADAPTIVE_PLAN_STATUS_SUCCESS]: updateAtpPlanStatus,
    [FETCH_PLAN_CONTENT_SUCCESS]: fetchPlanContent(true),
    [FETCH_PLAN_CONTENT_ERROR]: fetchPlanContent(false),
    [PLAN_SETUP_RESET]: resetPlanSetup,
    [UPDATE_PLAN_SETUP]: updatePlanSetup,
    [FETCH_COACH_CAUTION_SUCCESS]: fetchCoachCaution(true),
    [FETCH_COACH_CAUTION_ERROR]: fetchCoachCaution(false),
    [FETCH_PREPLAN_DISTANCE_SUCCESS]: fetchPreplanDistance(true),
    [FETCH_PREPLAN_DISTANCE_ERROR]: fetchPreplanDistance(false),
    [FETCH_PREPLAN_PACE_SUCCESS]: fetchPreplanPace(true),
    [FETCH_PREPLAN_PACE_ERROR]: fetchPreplanPace(false),
    [FETCH_PREPLAN_GOALS_SUCCESS]: fetchPreplanGoals(true),
    [FETCH_PREPLAN_GOALS_ERROR]: fetchPreplanGoals(false),
    [FETCH_PREPLAN_PACE_TIMES_SUCCESS]: fetchPreplanPaceTimes(true),
    [FETCH_PREPLAN_PACE_TIMES_ERROR]: fetchPreplanPaceTimes(false),
    [FETCH_PREPLAN_COACHES_SUCCESS]: fetchPreplanCoaches(true),
    [FETCH_PREPLAN_COACHES_ERROR]: fetchPreplanCoaches(false),
    [FETCH_PREPLAN_COACH_INFO_SUCCESS]: fetchPreplanCoachInfo(true),
    [FETCH_PREPLAN_COACH_INFO_ERROR]: fetchPreplanCoachInfo(false),
    [FETCH_COACH_VIDEO_SUCCESS]: fetchCoachVideo(true),
    [FETCH_COACH_VIDEO_ERROR]: fetchCoachVideo(false),
    [RESET_ATP_PLAN]: resetAtpPlan,
    [REQUEST_ATP_ACTIVE_FETCHING]: fetchingActiveAdaptiveTrainingPlans,
    [REQUEST_ATP_ACTIVE_FAIL]: fetchingActiveAdaptiveTrainingPlansFail,
    [RESET_PREPLAN_DISTANCE]: resetPreplanDistance,
    [RESET_PREPLAN_PACE_TIMES]: resetPreplanPaceTimes,
    [RESET_PREPLAN_PACE]: resetPreplanPace,
    [RESET_COACH_VIDEO]: resetCoachVideo
};

export const getATPPlan = (state) => state.atpPlan.entity;
export const getCompletedAdaptiveTrainingPlans = (state) => state.atpPlan.completedPlans || [];
export const getActiveAdaptiveTrainingPlans = (state) => state.atpPlan.activePlans || [];
export const getPlanTypes = (state) => state.atpPlan.atpPlanTypes || [];
export const isFetchingATP = (state) => state.atpPlan.isEntityFetching;
export const isFetchingError = (state) => state.atpPlan.status;
export const getCoachPlan = (state) => state.atpPlan.coachPlan;
export const getPlanContent = (state, workoutPlanId) => {
    if (state.atpPlan.content[workoutPlanId]) {
        return state.atpPlan.content[workoutPlanId];
    } else {
        return {};
    }
};
export const getCoachPlanSetup = (state) => {
    return state.atpPlan.inProcessPlanSetup;
};
export const getCoachCaution = (state) => {
    return state.atpPlan.coachAction;
};
export const getPreplanDistance = (state) => {
    return state.atpPlan.preplanDistance;
};
export const getPreplanPace = (state) => {
    return state.atpPlan.preplanPace;
};
export const getPreplanGoals = (state) => {
    return state.atpPlan.preplanGoals;
};
export const getPreplanPaceTimes = (state) => {
    return state.atpPlan.preplanPaceTimes?.data;
};
export const isPreplanPaceTimesError = (state) => {
    return state.atpPlan.preplanPaceTimes?.error;
};
export const getPreplanCoaches = (state) => {
    return state.atpPlan.preplanCoaches;
};
export const getPreplanCoachInfo = (state, contentId) => {
    return state.atpPlan.preplanCoachInfo[contentId];
};
export const getCoachInfoWithVideo = (state, contentId) => {
    return state.atpPlan.coachInfoWithVideo[contentId];
};
export const getCoachsInfoWithVideo = (state) => {
    return state.atpPlan.coachInfoWithVideo;
};
export const isActivePlanFetchSuccess = (state) => {
    return state.atpPlan.isActivePlanFetchSuccess;
};

export const isActivePlanFetchFail = (state) => {
    return state.atpPlan.isActivePlanFetchError;
};

export const isActivePlanFetching = (state) => {
    return state.atpPlan.isEntityFetching;
};

export default function atpPlan(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function requestPlanTypes({ lang }, evictCache = true) {
    return {
        type: REQUEST_ATP_TYPES,
        payload: lang,
        meta: {
            cacheTime: evictCache ? null : 60000
        }
    };
}

export function fetchActivePlans(evictCache = true) {
    return {
        type: REQUEST_ATP_ACTIVE,
        meta: {
            cacheTime: evictCache ? null : 60000
        }
    };
}

export function fetchCompletedPlans() {
    return {
        type: REQUEST_ATP_COMPLETED
    };
}

export function requestAdaptivePlan(params) {
    return {
        type: FETCH_ADAPTIVE_PLAN,
        payload: {
            athletePlanId: params.athletePlanId,
            lang: params.lang,
            callback: params.callback
        }
    };
}

export function fetchCoachPlan(workoutPlanId, lang) {
    return {
        type: FETCH_COACH_PLAN,
        payload: {
            workoutPlanId,
            lang
        }
    };
}

export function resetCoachPlanSetup() {
    return {
        type: PLAN_SETUP_RESET
    };
}

export function updateCoachPlanSetup(data) {
    return {
        type: UPDATE_PLAN_SETUP,
        data
    };
}

export function requestAtpPlanReset() {
    return {
        type: RESET_ATP_PLAN
    };
}
